module.exports = __webpack_public_path__ + "static/media/47.40ad5244.jpg";